import { DefaultTranslations } from "../../../../utils/seedDefaultTranslation";

export interface TranslationResult {
  tabId: TabId;
  tabSectionKey: TabSectionKey;
  attributeKey: AttributeKey;
  attributeValue: string;
  languageCode?: string;
}

export interface UpdateTranslation {
  attributeKey: string;
  attributeValues: AttributeValues[];
  adminUser: string;
}

export interface AttributeValues {
  attributeValue: string;
  language: string;
}

export enum ModeType {
  FIND = "FIND",
  TRANSLATE = "TRANSLATE",
}

export interface findOrReplaceParams {
  word: string;
  mode: ModeType;
  limit?: number;
  offset?: number;
  orderBy?: string;
  sort?: string;
}

export interface TranslationPaginatedResult {
  count: number;
  previousPage: string;
  nextPage: string;
  rows: TranslationResult[];
}

export interface PortalLanguageTranslation {
  languageCode: string;
  translation: string;
}

export interface ReplaceTranslationBodyParams {
  wordFind: string;
  wordReplace: string;
  translations: PortalLanguageTranslation[];
  attributes: TranslationResult[];
  adminUser: string;
}

export interface TranslationValueDetail {
  mainValue: string | null;
  ownValue: string | null;
  effectiveValue: string;
  source: "main" | "own";
  isOverridden: boolean;
}

export interface TranslationManageAttributeResult {
  attributeKey: string;
  attributeOrder: number;
  values: Record<string, TranslationValueDetail>;
}

export interface TranslationManageResult {
  tabId: string;
  tabSectionKey: string;
  attributes: TranslationManageAttributeResult[];
}

export type TabId = keyof typeof DefaultTranslations;

export type SectionOf<T extends TabId> = keyof (typeof DefaultTranslations)[T] &
  string;

export type KeyOf<
  T extends TabId,
  S extends SectionOf<T>,
> = keyof (typeof DefaultTranslations)[T][S] & string;

export type TabSectionKey = { [T in TabId]: SectionOf<T> }[TabId];
export type AttributeKey = {
  [T in TabId]: { [S in SectionOf<T>]: KeyOf<T, S> }[SectionOf<T>];
}[TabId];

export const TRANSLATION_TAB_IDS = Object.keys(DefaultTranslations) as TabId[];
